// JsFromRoutes CacheKey f8dee5f38bccc7c9fbd76ccfd635b6f5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  run: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/imports/:id/run'),
  rollback: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/imports/:id/rollback'),
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/imports'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/imports'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/imports/:id'),
}
